import { render, staticRenderFns } from "./DefinePasswordPage.vue?vue&type=template&id=233e5784"
import script from "./DefinePasswordPage.vue?vue&type=script&lang=js"
export * from "./DefinePasswordPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports